module.exports = __webpack_public_path__ + "static/religious-liberty-01d7ae8893027ad218d9c312b5fa188c.jpg";